/**
 * Cloud resource export configuration
 *
 * Shared by all cloud resource types:
 * - AWSResource
 * - GCPResource
 * - AzureResource
 * - CloudResource
 */

import type { ExportColumnConfig } from '@/components/export/universal/types';

export const CLOUD_COLUMNS: readonly ExportColumnConfig[] = [
  { id: 'resource_name', label: 'Resource Name', defaultSelected: true },
  { id: 'display_name', label: 'Display Name', defaultSelected: true },
  { id: 'provider', label: 'Provider', defaultSelected: true },
  { id: 'resource_type', label: 'Resource Type', defaultSelected: true },
  { id: 'region', label: 'Region', defaultSelected: true },
  { id: 'account_ref', label: 'Account' },
  { id: 'ips', label: 'IP Addresses' },
  { id: 'urls', label: 'URLs' },
  { id: 'status', label: 'Status', defaultSelected: true },
  { id: 'tags', label: 'Tags' },
  { id: 'notes', label: 'Notes' },
  { id: 'first_seen', label: 'First Seen', defaultSelected: true },
  { id: 'last_seen', label: 'Last Seen', defaultSelected: true },
];
